import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import GetStartedCta from "./sections/GetStartedCta";
import Posts from "./sections/Posts";
import Uber from "./sections/Uber";
import BookAPrivateSession from "./sections/BookAPrivateSession";
import Noga from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <GetStartedCta />
      <Posts />
      <Uber />
      <BookAPrivateSession />
      <Noga />
    </div>;
}